<p-toast position="top-center" key="subscribe"></p-toast>

<div *ngIf="!pageStateService.hideSubscribePanel" class="subscribePanel">
  <div class="bg-img" style="background-image: url(../../../assets/images/SubscribeBG.avif)"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 text-center">
        <!-- <h3>{{ 'SubscribeDes' | translate }}</h3> -->
        <span class="subscribePanelP">{{ 'SubscribeDes' | translate }}</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <p class="subscribe-btn">
          <button translate (click)="showEmailSubscribeDialog()" class="btn btn-primary btn-lg" target="_blank">
            {{ 'Join now!' | translate }}
          </button>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="emailSubscribe">
  <p-dialog
    header="{{ 'SUBSCRIBE' | translate }}"
    [(visible)]="subscribeEmailDialogue"
    [style]="{ width: '50vw' }"
    [baseZIndex]="10000"
    closable="true"
    (onHide)="closeEmailSubscribeDialog()"
  >
    <iframe src="../../assets/html/subscriber.html"></iframe>
  </p-dialog>
</div>
<div class="iconNavSection noDesktop">
  <p-carousel
    [value]="products"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
  >
    <ng-template let-product pTemplate="item">
      <div class="product-item-content text-center">
        <div class="footerNavImg">
          <a href="{{ product.url }}" target="_blank"> <img src="{{ product.icon }}" [alt]="product.name" /></a>
        </div>
        <h4 class="p-mb-1 footer-icon-title">{{ product.name }}</h4>
      </div>
    </ng-template>
  </p-carousel>
</div>
<div class="iconNavSection noMobile">
  <p-carousel
    [value]="products"
    [numVisible]="5"
    [numScroll]="1"
    [circular]="true"
    [responsiveOptions]="responsiveOptions"
  >
    <ng-template let-product pTemplate="item">
      <div class="product-item-content text-center">
        <div class="footerNavImg">
          <a href="{{ product.url }}" target="_blank"> <img src="{{ product.icon }}" [alt]="product.name" /></a>
        </div>
        <!-- <h4 class="p-mb-1 footer-icon-title">{{ product.name }}</h4> -->
        <span class="p-mb-1 footer-icon-title footerIconNavSection">{{ product.name }}</span>
      </div>
    </ng-template>
  </p-carousel>
</div>
<div class="footer">
  <!-- footer-->
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-4 text-center">
        <a href="/home"
          ><img style="width: 210px; height: 150px" src="/assets/images/footerlogoc.png" alt="The Seychelles Islands"
        /></a>
        <ul class="footerSocialIcons">
          <li *ngFor="let imageItem of footerSocialLinks">
            <a
              target="_blank"
              href="{{ imageItem.url }}"
              aria-label="To Navigate to different seychelles social media account"
              ><i class="{{ imageItem.icon }}"></i
            ></a>
          </li>
        </ul>
        <ul class="appIconsUl">
          <li *ngFor="let appItem of footerMenuApps">
            <a href="{{ appItem.url }}" target="_blank"><img src="{{ appItem.icon }}" /></a>
          </li>
        </ul>
      </div>

      <div class="col-md-8 noDesktop">
        <ul class="footerMobileMenu">
          <li *ngFor="let item of footerMobileMenu">
            <a href="{{ item.url }}">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <div class="col-md-2 noMobile">
        <h1 class="footerItemsMenu">{{ footerMainMenu.name }}</h1>
        <ul class="footerMenu">
          <li *ngFor="let innerItem of footerMainMenu.children">
            <a href="{{ innerItem.url }}">{{ innerItem.name }}</a>
          </li>
        </ul>
      </div>
      <div class="col-md-2 noMobile">
        <h1 class="footerItemsMenu">{{ islandsFooter.name }}</h1>
        <ul class="footerMenu">
          <li *ngFor="let innerItem of islandsFooter.children">
            <a href="{{ innerItem.url }}">{{ innerItem.name }}</a>
          </li>
        </ul>
      </div>
      <div class="col-md-4 noMobile footerExperience">
        <h1 class="footerItemsMenu">{{ experienceFooter.name }}</h1>
        <div class="row">
          <ng-container *ngFor="let innerItem of experienceFooter.children">
            <a class="col-6" href="{{ innerItem.url }}">{{
              innerItem.name === 'Sustainability' ? 'Sustainable Seychelles' : innerItem.name
            }}</a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- // footer-->
<div class="footerCopyrights">
  <!-- copy rights-->
  <div class="container-fluid">
    <div class="noMobile">
      <div class="row privacyPolicy">
        <ul>
          <li *ngFor="let item of footerTCPrivacy">
            <a href="{{ item.url }}">{{ item.name | translate }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">
      <div class="col copyrightsText">
        {{ 'All rights reserved' | translate }}. &copy; 2025 {{ 'The Seychelles Islands' | translate }}
      </div>
    </div>
  </div>
</div>
<!-- // copy rights-->
